import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
const KIND_CLASSES = {
    alert: {
        ring: 'border-[color-mix(in_oklab,var(--color-rose)_40%,transparent)]',
        bg: 'bg-[var(--color-rose-soft)]',
        text: 'text-[var(--color-rose)]',
    },
    signal: {
        ring: 'border-[color-mix(in_oklab,var(--color-accent)_40%,transparent)]',
        bg: 'bg-[var(--color-accent-soft)]',
        text: 'text-[var(--color-accent)]',
    },
    agent: {
        ring: 'border-[color-mix(in_oklab,var(--color-steel)_40%,transparent)]',
        bg: 'bg-[var(--color-steel-soft)]',
        text: 'text-[var(--color-steel)]',
    },
    win: {
        ring: 'border-[color-mix(in_oklab,var(--color-sage)_40%,transparent)]',
        bg: 'bg-[var(--color-sage-soft)]',
        text: 'text-[var(--color-sage)]',
    },
};
export function NotifRow({ kind, icon, title, meta, trailing, unread = false, onClick, className, }) {
    const tone = KIND_CLASSES[kind];
    const interactive = Boolean(onClick);
    const sharedClass = cn('grid w-full grid-cols-[22px_1fr_auto] items-start gap-3.5 border-b border-[var(--color-line)] px-4 py-3.5 text-start', interactive &&
        'cursor-pointer transition-colors hover:bg-[var(--color-surface)] focus-visible:outline-none focus-visible:bg-[var(--color-surface)]', unread && 'bg-[color-mix(in_oklab,var(--color-accent)_4%,transparent)]', className);
    const body = (_jsxs(_Fragment, { children: [_jsx("span", { className: cn('mt-px inline-grid size-5.5 place-items-center rounded-pill border font-mono text-2xs', tone.ring, tone.bg, tone.text), "aria-hidden": true, children: icon }), _jsxs("div", { className: "min-w-0", children: [_jsx("div", { className: "text-sm leading-snug text-[var(--color-ink)]", children: title }), meta && (_jsx("div", { className: "mt-1 font-mono text-2xs uppercase tracking-[0.1em] text-[var(--color-ink-muted)]", children: meta }))] }), trailing && _jsx("div", { className: "text-end", children: trailing })] }));
    if (interactive) {
        return (_jsx("button", { type: "button", onClick: onClick, className: sharedClass, children: body }));
    }
    return (_jsx("div", { role: "listitem", className: sharedClass, children: body }));
}
